import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DownloadExcelButton from "components/ReportUI/Downloadexcelbutton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DistanceReportsTable from "./distancereporttable";
import { distancereportendpoint } from "config";
import { accountmy } from "config";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


function DistanceReport() {
  const [distanceData, setDistanceData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [orgName, setorgName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    handleAccount()
    // fetchGeoFences()
  }, [])
 

  const today = new Date();

   const startTimeDefault = new Date(today.getFullYear(), today.getMonth(), today.getDate());
 const endTimeDefault = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const [startTime, setStartTime] = useState(startTimeDefault);
  const [endTime, setEndTime] = useState(endTimeDefault);

  // Snackbar handlers
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  const handleAccount = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      const response = await axios.get(accountmy, {
        headers: {
          "x-dhundhoo-session": token,
        },
      });


      const orgName = response?.data.orgInfo?.orgName || "";


      setorgName(orgName);
    } catch (error) {
      console.error("API Error in handleAccount:", error);

    } finally {
      setLoading(false);
    }
  };
  

  // Columns for DataTable
  const columns = [
    { Header: "Vehicle Number", accessor: "thingName", width: "20%" },
    { Header: "From Date", accessor: "startDate", width: "20%" },
    { Header: "To Date", accessor: "endDate", width: "20%" },
    { Header: "Total Distance (Km)", accessor: "distance", width: "20%" },

  ];

  const fetchLogs = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      const formatDate = (date) => {


        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      };
      const formatDateOnly = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const token = localStorage.getItem("token");
      const data = JSON.stringify({
        date: formatDateOnly(today),
        zone: "Asia/Kolkata",
        startTime: formatDate(startTime),
        endTime: formatDate(endTime),
        orgName: orgName,
      });

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: distancereportendpoint,
        headers:
        {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json"
        },
        data,
      };

      const response = await axios.request(config);

      const formattedRows = response.data.map((log) => ({
        startDate: log.startDate,
        thingName: log.thingName,
        endDate: log.endDate,
        // distance: log.distance,
        distance: log.distance ? Number(log.distance).toFixed(3) : "0.000",
      }));

      setDistanceData(formattedRows);
      openSuccessSB();
    } catch (error) {
      console.error(error);
      setErrorMessage("Error loading  Distance report");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };


  const exportToCSV = () => {
    if (distanceData.length === 0) {
      setErrorMessage("No data to export");
      openErrorSB();
      return;
    }
   
    
   
    
    const headers = ["Vehicle Number", "From Date", " To Date", "Total Distance (Km)"];
    const rows = distanceData.map((row) =>
      [row.thingName,row.startDate, row.endDate, row.distance].join(",")
    );
    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `DistanceReport.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClear = () => {

    setStartTime(startTimeDefault);
    setEndTime(endTimeDefault);
    setDistanceData([]);
    setErrorMessage("");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} pb={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container spacing={2}>



                    {/* Start Time Picker */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DatePicker
                        label="Start Date"
                        value={startTime}
                        onChange={(newValue) => setStartTime(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                      />
                      
                    </Grid>

                    {/* End Time Picker */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DatePicker
                        label="End Date"
                        value={endTime}
                        onChange={(newValue) => setEndTime(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                      />
                    </Grid>


                    <Grid item xs={4} sm={2} md={1}>
                      <MDButton
                        fullWidth
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={fetchLogs}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : "LOAD"}
                      </MDButton>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1}>
                      <MDButton
                        fullWidth
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={handleClear}
                        disabled={loading}
                      >
                        CLEAR
                      </MDButton>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1}>
                      <DownloadExcelButton fullWidth label="CSV" onClick={exportToCSV} disabled={loading} />
                    </Grid>
                  </Grid>
                </LocalizationProvider>
              </MDBox>

              {/* Error alert */}
              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              {/* Table or loader */}
              <MDBox pt={3} display="flex" justifyContent="center">
                {loading ? (
                  <CircularProgress /> // ✅ center loader while fetching
                ) : (
                  <DistanceReportsTable
                    table={{ columns, rows: distanceData }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Snackbars */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Distance Report"
        content="Data Loaded Successfully"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="Distance Report"
        content="Failed to load logs. Please try again."
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default DistanceReport;
